/** Strip comments from `layout/types.ts` before embedding in the vibecoder bundle. */
export function stripTypesForVibecode(src: string): string {
  return src
    .replace(/\/\*\*[\s\S]*?\*\//g, '')
    .replace(/^\s*\/\/[^\n]*/gm, '')
    .replace(/\n{3,}/g, '\n\n')
    .trim();
}
